<template>
  <div class="aco-grid">
    <div class="aco-info-box">
      <organizations-filter/>
    </div>
    <div class="aco-details-box">
      <organization-list/>
    </div>
  </div>
</template>

<script>
  import OrganizationsFilter from './OrganizationFilter'
  import OrganizationList from './OrganizationList'

  export default {
    components: {
      organizationsFilter: OrganizationsFilter,
      organizationList : OrganizationList
    }
  }
</script>
